import {
  Autocomplete,
  FormControl,
  FormLabel,
  TextField,
  Typography,
} from "@mui/material";
import { timezoneList } from "Constants/data";
import React from "react";
import { useSelector } from "react-redux";

const TimezoneSelect = ({
  label = "Time Zone",
  value,
  onBlur = () => {},
  onChange = () => {},
  error,
}) => {
  const { Common, Translation } = useSelector((state) => ({
    Common: state.Common.common,
    Translation: state.Translation.translation?.Common || {},
  }));

  const timezoneList = Common?.Timezone || [];

  const selectedOption = React.useMemo(() => {
    return timezoneList.find((item) => item.ID === value) || null;
  }, [timezoneList, value]);

  return (
    <FormControl fullWidth>
      <FormLabel color="secondary" required label>
        {/* {label} */}
        {Translation?.TimeZone}
      </FormLabel>
      <Autocomplete
        options={timezoneList}
        autoHighlight
        getOptionLabel={(option) => option.Value}
        clearIcon={false}
        value={selectedOption}
        onBlur={onBlur}
        onChange={(value, newVal) => onChange(newVal)}
        noOptionsText={<Typography>{Translation?.NoResultsFound}</Typography>}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <Typography key={key} {...optionProps}>
              {option?.Value}
            </Typography>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            error={Boolean(error)}
            name="TimezoneID"
            placeholder={Translation?.SelectTimeZone}
            helperText={error}
            slotProps={{
              htmlInput: {
                ...params.inputProps,
                autoComplete: "new-password",
              },
            }}
          />
        )}
      />
    </FormControl>
  );
};

export default React.memo(TimezoneSelect);
